import { query , proxy_api } from "@core/helpers/graphql";
import { GET_MEGA_MENU, GET_MEGA_MENUS } from "./_queries";

export const get_mega_menu = async (variables, options = {}) => {
    const { gql } = options
    const result = await query(gql || GET_MEGA_MENU, variables, options);

    return {
        data: gql ? result?.data : result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}

export const get_mega_menus = async (variables, options = {}) => {
    const { gql } = options
    const result = await query(gql || GET_MEGA_MENUS, variables, options);

    return {
        data: gql ? result?.data : result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}

export const get_mega_menus_proxy = async (variables = {}, options = {}) => {
    const { gql } = options
    const result = await proxy_api({
        type: 'query',
        gql: gql || GET_MEGA_MENUS,
        variables,
        options,
        cacheOptions: {
            name: 'mega_menus',
            ttl: 60 * 5,
            keys: {}
        }
    });

    return {
        data: gql ? result?.data : result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}